import { useState } from "react";
import { HStack } from "../../components/utils";
import { AddOrEditBonusDetails } from "../../modals/AddOrEditBonusDetails";
import { AddOrEditBonusRatioChangeDetails } from "./AddOrEditBonusRatioChangeDetails";

type BonusType = "AddBonus" | "AddBonusRatioChange";

interface BonusTypeSelectorProps {
  onClose: () => void;
  setDialog: Function;
  setBonusRatioChangeDialog: Function;
}

export function BonusTypeSelector({
  onClose,
  setDialog,
  setBonusRatioChangeDialog,
}: BonusTypeSelectorProps) {
  const [selectedType, setSelectedType] = useState<BonusType>("AddBonus");

  return (
    <div>
      <div className="text-lg font-medium">
        <div className="text-lg font-medium border-b py-7">
          <h6 className="px-10 flex justify-between">
            <p className="font-bold">Bonus Event Details</p>
            <span onClick={() => onClose()} className="cursor-pointer">
              X
            </span>{" "}
          </h6>
        </div>
      </div>
      <div>
        <div className="flex items-center gap-1 py-5 px-10">
          <span className="text-sm text-gray-500 font-normal whitespace-nowrap">
            Choose Bonus Method
          </span>
          <HStack className="gap-6 ml-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="bonusType"
                value="AddBonus"
                checked={selectedType === "AddBonus"}
                onChange={() => setSelectedType("AddBonus")}
                className="accent-orange-500"
              />
              <span className="text-sm font-normal">Issue new grants</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="bonusType"
                value="AddBonusRatioChange"
                checked={selectedType === "AddBonusRatioChange"}
                onChange={() => setSelectedType("AddBonusRatioChange")}
                className="accent-orange-500"
              />
              <span className="text-sm font-normal">
                Update conversion ratio
              </span>
            </label>
          </HStack>
        </div>
      </div>
      {selectedType === "AddBonus" ? (
        <AddOrEditBonusDetails
          mode="AddBonus"
          onClose={onClose}
          setDialog={setDialog}
          hideHeader
        />
      ) : (
        <AddOrEditBonusRatioChangeDetails
          mode="AddBonusRatioChange"
          onClose={onClose}
          setDialog={setBonusRatioChangeDialog}
          hideHeader
        />
      )}
    </div>
  );
}

export default BonusTypeSelector;
